//Well, is it?
export function isTrue(string: string) {
    return string === "true"
}
